
import { defineComponent, onMounted } from 'vue';
import {
    AppFormRow,
    AppInput,
    AppCard,
    AppButton,
    AppSelect,
    AppSwitch,
    AppFileUpload,
    AppAvatarBreadcrumb
} from '@/components';
import { useAvatarCategoryAdd } from '@/modules/avatar/category/model/add';
import { AvatarGender } from '@/modules/avatar/gender/model/gender';
import { ROUTE_NAME_AVATAR } from '@/modules/avatar/router';

export default defineComponent({
    name: ROUTE_NAME_AVATAR.CATEGORY.ADD,
    components: { AppFormRow, AppInput, AppCard, AppButton, AppSelect, AppSwitch, AppFileUpload, AppAvatarBreadcrumb },
    setup() {
        const { model, v$, actions } = useAvatarCategoryAdd();

        onMounted(() => {
            actions.fetch();
        });

        return { v$, model, actions, AvatarGender };
    }
});
